import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css'
import 'react-quill/dist/quill.snow.css'
import {RootState} from '../../store'
import ErrorMsg from './NewMsgErr'
import MaxCharactersNote from './MaxCharactersNote'
import {Stack} from '@mui/material'

const Editor: React.FC<any> = ({name, formik, child, errors, characters}: any) => {
  const store = useSelector((state: RootState) => state.vender)
  const [languages, setLanguages] = useState(['en'])
  const [isDone, setIsDone] = useState(false)
  const editorRef = useRef<any>(null)

  useEffect(() => {
    setIsDone(false)
    setLanguages(store.storeLangs)
    setTimeout(() => {
      setIsDone(true)
    }, 10)
  }, [store.storeLangs])

  useEffect(() => {
    setIsDone(false)
    setTimeout(() => {
      setIsDone(true)
    }, 10)
  }, [formik.values])

  const handleChange = (content: string) => {
    if (editorRef.current) {
      editorRef.current.latestContent = content
    }
  }

  const handleBlur = () => {
    const content = editorRef.current?.latestContent ?? editorRef.current?.getContents?.()
    if (typeof content === 'string') {
      formik.setFieldValue(`${child}[${name}]`, content)
      console.log(`✅ Saved ${child}[${name}]:`, content)
    } else {
      console.warn(`⚠️ Content undefined for ${child}[${name}]`)
    }
  }

  const arabicFonts = [
    'Amiri',
    'Scheherazade New',
    'Noto Sans Arabic',
    'Harmattan',
    'Reem Kufi',
    'Cairo',
    'El Messiri',
    'Tajawal',
    'Markazi Text',
    'Lateef',
    'Katibeh',
    'Almarai',
    'Droid Arabic Kufi',
    'Changa',
    'Mada',
    'Rakkas',
    'Lemonada',
    'Aref Ruqaa',
    'Readex Pro',
    'IBM Plex Sans Arabic',
    'Areh',
    'Mirza',
    'Kufam',
    'Baloo Bhaijaan 2',
    'Sonsie One Arabic',
    'Aref Ruqaa Ink',
    'Jomhuria',
    'Vibes',
    'Marhey',
  ]

  const englishFonts = [
    'Open Sans',
    'Lato',
    'Montserrat',
    'Poppins',
    'Roboto',
    'Merriweather',
    'Playfair Display',
    'Source Sans 3',
    'Nunito Sans',
    'PT Sans',
    'Fira Sans',
    'Karla',
    'Libre Baskerville',
    'Work Sans',
    'Cabin',
    'Arvo',
    'EB Garamond',
    'Hind',
    'Comfortaa',
    'Exo 2',
    'Inter',
    'Lora',
    'Manrope',
    'IBM Plex Sans',
    'Outfit',
    'Space Mono',
    'Prompt',
    'Plus Jakarta Sans',
    'Spline Sans',
    'DM Sans',
    'Ubuntu',
    'Cormorant Garamond',
    'Cinzel Decorative',
    'Bodoni Moda',
    'Bellefair',
    'Cardo',
    'Josefin Slab',
    'Crimson Text',
    'Alegreya',
    'Fanwood Text',
    'Prata',
    'Nunito',
    'Quicksand',
    'Kalam',
    'Rubik',
    'Gochi Hand',
    'Patrick Hand',
    'Varela Round',
    'Caveat',
    'Oswald',
    'Bebas Neue',
    'Anton',
    'Alfa Slab One',
    'Michroma',
    'Staatliches',
    'Squada One',
    'Paytone One',
    'Russo One',
    'Lobster Two',
    'Pacifico',
    'Permanent Marker',
    'Great Vibes',
    'Dancing Script',
    'UnifrakturMaguntia',
    'Special Elite',
    'Sacramento',
    'Limelight',
    'Press Start 2P',
    'Shadows Into Light',
    'Metal Mania',
  ]

  return (
    <>
      <Stack sx={{minHeight: {xs: '500px', md: '417px'}}}>
        {isDone &&
          languages.map((ele: string) => (
            <React.Fragment key={ele}>
              {name === ele && (
                <SunEditor
                  defaultValue={formik.values[child]?.[name] || ''}
                  getSunEditorInstance={(sunEditor) => {
                    editorRef.current = sunEditor
                  }}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  setOptions={{
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['removeFormat'],
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'table'],
                      ['link'],
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview', 'print'],
                    ],
                    font: name === 'ar' ? arabicFonts : englishFonts,
                  }}
                />
              )}
            </React.Fragment>
          ))}
      </Stack>

      <MaxCharactersNote characters={characters} />

      {errors && errors[child] && typeof errors[child] === 'string' && !name && (
        <ErrorMsg msgErr={errors[child]} />
      )}

      {errors && errors[`${child}.${name}`] && typeof errors[`${child}.${name}`] === 'string' && (
        <ErrorMsg child={name} msgErr={errors[`${child}.${name}`]} />
      )}
    </>
  )
}

export default Editor
